import type { AxleAiMessage } from "./types";

const TITLE_LENGTH = 60;

// Chats are saved by automatic; which one was open is a per-browser preference.
const ACTIVE_CHAT_KEY = "axleAi.activeChat";

const readActiveChats = (): Record<string, string> => {
  try {
    return JSON.parse(localStorage.getItem(ACTIVE_CHAT_KEY) ?? "{}");
  } catch {
    return {};
  }
};

/** The chat that was open for the client, so coming back reopens it. */
export const activeChatIdFor = (clientId: string): string | undefined =>
  readActiveChats()[clientId];

/** Remembers the open chat for the client; no id means a new chat. */
export const rememberActiveChat = (clientId: string, chatId?: string) => {
  try {
    const { [clientId]: _previous, ...others } = readActiveChats();
    localStorage.setItem(
      ACTIVE_CHAT_KEY,
      JSON.stringify(chatId ? { ...others, [clientId]: chatId } : others)
    );
  } catch (error) {
    console.warn("Could not remember the open Axle AI chat", error);
  }
};

export const newChatId = () =>
  `chat_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

/** The first question, shortened, so the chat list reads like ChatGPT's. */
export const chatTitle = (messages: AxleAiMessage[]) => {
  const first = messages.find(
    (message) => message.role === "user" && typeof message.content === "string"
  );
  const text = (first?.content as string | undefined)?.trim() || "New chat";
  return text.length > TITLE_LENGTH
    ? `${text.slice(0, TITLE_LENGTH - 1)}…`
    : text;
};
